import { resolveProductImageDisplayUrl, buildImageUrlFromUpload } from '../../product/utils/productHelpers';

export const toBooleanFromBit = (value, defaultValue = false) => {
  if (value === true || value === 1 || value === '1') return true;
  if (value === false || value === 0 || value === '0') return false;
  if (value && typeof value === 'object' && value.type === 'Buffer' && Array.isArray(value.data)) {
    return value.data[0] === 1;
  }
  return defaultValue;
};

/** Resolve ec_vendor.VendorLogo for browser preview (same storage settings as product images). */
export const resolveVendorLogoDisplayUrl = (logoUrl) => resolveProductImageDisplayUrl(logoUrl);

/** Build full VendorLogo URL from filelibrary FilePath using configured PublicAssetBaseUrl. */
export const buildVendorLogoUrlFromUpload = (filePath) => buildImageUrlFromUpload(filePath);